<p-card class="dashBoard" #card>
  <div style="position:relative">
    @if (!ps.hasAnyRole(['ROLE_MODEL_SEC_MANAGER'])) {
<div  style="
      position: absolute;
      top: 0;
      bottom: 0;
      width: 100%;
      opacity: 0.5;
      background-color: white;
      height: 100%;">
      </div>
    }
    <div class="title" (click)="showModels()">Top Models</div>
    <br class="clear"/>
    @if (!data) {
      <div class='loading-spinner'></div>
    }
    @if (data) {
      <div>
        <div class="chart">
          <div>
            <p-chart type="doughnut" [data]="chartData" [options]="options" width="100%" height="100px"></p-chart>
          </div>
          <div class="pane">
            <table class="dashboard-table">
              <tr class="header key">
                <td class="">Model Name</td>
                <td class="alignRight" style="width: 60px">Portfolios</td>
                <td class="alignRight" style="width: 140px">AUM</td>
                <td class="" style="width: 15px"></td>
              </tr>
              @for (item of data.topModels; track item; let i = $index) {
                <tr class="row key clickable" (click)="showModelDetail(item.modelId, item.modelName)">
                  <td class="item">
                    <div class="cell"><div class="swatch" [style.backgroundColor]="colors[i]"></div></div>
                    <div class="cell label truncate" tooltip [tooltipTitle]="item.modelName" [tooltipRequiresTruncation]="true" tooltipPosition="right" [tooltipHorizontalOffset]="0">{{item.modelName}}</div>
                  </td>
                  <td class="alignRight">{{item.portfolioCount}}</td>
                  <td class="alignRight">${{item.aum | number}}</td>
                  <td><fa-icon [icon]="faChevronRight"></fa-icon></td>
                </tr>
              }
              @for (item of data.remainingModels; track item; let i = $index) {
                <tr class="row key">
                  <td class="item">
                    <div class="cell"><div class="swatch" [style.backgroundColor]="colors[5]"></div></div>
                    <div class="cell label truncate">Other</div>
                  </td>
                  <td class="alignRight">{{item.portfolioCount}}</td>
                  <td class="alignRight">${{item.aum | number}}</td>
                  <td></td>
                </tr>
              }
            </table>
          </div>
          <br class="clear"/>
        </div>
      </div>
    }
  </div>
</p-card>
